import { useContext, useEffect, useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PackContext from '@contexts/packContext'
import PageContext from '@contexts/pageContext'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import handleCallbackAction from '@functions/handleCallbackAction'

import ManagePublicationBookingPreflightStatusModal from '@modals/ManagePublicationBookingPreflightStatusModal'

import type { PublicationBookingModel } from '@models/types'

import PageContent from './components/PageContent'

type DefaultState = {
  showPublicationBookingPreflightStatusModal: boolean,
}

const defaultState = {
  showPublicationBookingPreflightStatusModal: false,
}

type SetState = (state: Partial<DefaultState>) => void

const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManagePublicationBookingPreflightStatusModal: {
      closeModal: () => setState({ showPublicationBookingPreflightStatusModal: false }),
      updatePublicationBookingPreflightStatus: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}
interface ListProps {
  pageFilters: {
    [key: string]: any,
  },
}

const List = (props: ListProps) => {
  const { pageFilters } = props
  const [state, setState] = useSetState(defaultState)

  const {
    showPublicationBookingPreflightStatusModal,
  } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const packContext = useContext(PackContext)
  const { callbacks: { updateFilters } } = packContext

  useEffect(() => {
    updateFilters({ ...pageFilters, preflight_status: 'required' })
  }, [])

  const pageContext = useMemo(() => ({
    callbacks: {
      showPublicationBookingPreflightStatusModal: (payload: { publicationBooking: PublicationBookingModel }) => {
        setModalData('ManagePublicationBookingPreflightStatusModal', payload)
        setState({ showPublicationBookingPreflightStatusModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <ManagePublicationBookingPreflightStatusModal
          callbacks={callbacks('ManagePublicationBookingPreflightStatusModal', setState)}
          showModal={showPublicationBookingPreflightStatusModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
